import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-20" style={{
      background: 'rgba(248, 250, 255, 0.8)',
      backdropFilter: 'blur(20px) saturate(180%)',
      WebkitBackdropFilter: 'blur(20px) saturate(180%)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
      boxShadow: '0 4px 24px rgba(31, 38, 135, 0.08)'
    }}>
      <div className="container h-full">
        <nav className="flex items-center justify-between h-full">
          {/* Logo - Left Aligned */}
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_eqjourney-1/artifacts/esi0kvor_ChatGPT%20Image%20Jan%2029%2C%202026%2C%2001_08_19%20PM.png"
              alt="Emotional Intelligence Academy"
              className="h-20 w-auto"
              style={{ maxWidth: '400px' }} />

          </Link>

          {/* Desktop Navigation - Right Aligned */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-medium hover:text-brand-primary transition-colors">
              Home
            </Link>
            <Link to="/start-here" className="text-sm font-medium hover:text-brand-primary transition-colors">
              Books by Age
            </Link>
            <Link to="/series-overview" className="text-sm font-medium hover:text-brand-primary transition-colors">
              Overview
            </Link>
            <Link to="/blog" className="text-sm font-medium hover:text-brand-primary transition-colors">
              Blog
            </Link>
            <Link to="/about" className="text-sm font-medium hover:text-brand-primary transition-colors">
              About
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu">

            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen &&
        <div className="md:hidden absolute top-20 left-0 right-0 shadow-lg border-t" style={{
          background: 'rgba(248, 250, 255, 0.95)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)',
          borderColor: 'rgba(255, 255, 255, 0.3)'
        }}>
            <div className="flex flex-col p-4 gap-4">
              <Link
              to="/"
              className="text-sm font-medium hover:text-brand-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}>

                Home
              </Link>
              <Link
              to="/start-here"
              className="text-sm font-medium hover:text-brand-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}>

                Books by Age
              </Link>
              <Link
              to="/series-overview"
              className="text-sm font-medium hover:text-brand-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}>

                Overview
              </Link>
              <Link
              to="/blog"
              className="text-sm font-medium hover:text-brand-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}>

                Blog
              </Link>
              <Link
              to="/about"
              className="text-sm font-medium hover:text-brand-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}>

                About
              </Link>
            </div>
          </div>
        }
      </div>
    </header>);

};

export default Header;